import { HttpErrorResponse } from '@angular/common/http'
import { inject } from '@angular/core'

import { DEFAULT_NETWORK_ERROR_MESSAGE, ToastService } from '@app/overlays/toast/toast.service'
import { ErrorHandlers } from '@app/services/error-handlers.service'

export const injectDefaultErrorHandler = () => {
  const toastService = inject(ToastService)
  return (error: any): void => {
    if (error instanceof HttpErrorResponse) {
      toastService.show(DEFAULT_NETWORK_ERROR_MESSAGE)
    }
    ErrorHandlers.handleError(error)
  }
}
